const CancelIcon = ({ viewBox = "0 0 17 17", className = "hayley-h-[17px] hayley-w-[17px] hayley-text-white" }) => {
  return (
    <svg viewBox={viewBox} className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 1.5L1.5 15.5" stroke="black" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M15.5 15.5L1.5 1.5" stroke="black" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default CancelIcon;
